// @ts-nocheck
// Greif UI Kit = stroke-edit
import * as React from "react";

const EditLine: React.FC = () => {
    /* Store Custom Code - Start */
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M5 19h1.425L16.2 9.225 14.775 7.8 5 17.575zm-1 2a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 20v-2.425a1.98 1.98 0 0 1 .575-1.4L16.2 3.575q.3-.275.663-.425.362-.15.762-.15t.775.15.65.45L20.425 5q.3.275.438.65a2.17 2.17 0 0 1 0 1.512 1.9 1.9 0 0 1-.438.663l-12.6 12.6a1.975 1.975 0 0 1-1.4.575zM15.475 8.525l-.7-.725L16.2 9.225z"
            />
        </svg>
    );
    /* Store Custom Code - End */
};

export default React.memo(EditLine);
